import React, { useContext } from 'react';

import { ResearchContext } from '../../ResearchContext';

import SearchIcon from '@mui/icons-material/Search';

import {
    Button,
    CircularProgress,
    FormControl,
    Grid,
    InputLabel,
    LinearProgress,
    MenuItem,
    Select,
    Typography
} from '@mui/material';
import { SearchTypeOptions } from "../../../../../helpers";
import { ComuneFilter } from './ComuneFilter';
import { DistrettualeFilter } from './DistrettualeFilter';
import { LiberaFilter } from './LiberaFilter';
import { TerritorioFilter } from './TerritorioFilter';
import { TipoUfficioFilter } from './TipoUfficioFilter';


export const ResearchFilters = () => {

    const {

        state,
        setState,

        isLoadingComuni,
        getComuniAsync,

        isLoadingRegioni,
        getRegioniAsync,

        isLoadingProvince,
        getProvinceAsync,

        isLoadingDistretti,
        getDistrettiAsync,

        isLoadingCircondari,
        getCircondariAsync,

        isLoadingUfficiTipoUfficio,
        getUfficiTipoUfficioAsync,

        isLoadingUfficiLibera,
        getUfficiLiberaAsync,

        isLoadingUfficiDistretto,
        getUfficiDistrettoAsync,

        isLoadingUfficiTerritorio,
        getUfficiTerritorioAsync,

        isLoadingComuneUffici,
        getComuneUfficiAsync,

        isLoadingComuneAltriUffici,
        getComuneAltriUfficiAsync,

        isLoadingUffici,
        getUfficiAsync,

        userLocation,
        userComune,

        tipoUfficioFilter,
        setTipoUfficioFilter,

        testoFilter,
        setTestoFilter,

        comuneFilter,
        setComuneFilter,

        regioneFilter,
        setRegioneFilter,

        provinciaFilter,
        setProvinciaFilter,

        distrettoFilter,
        setDistrettoFilter,

        circondarioFilter,
        setCircondarioFilter,

        handleSearchSubmit,
        handleResetSearch,
        isLoadingFilterFromCookies,
        setIsLoadingFilterFromCookies,
        handleWidgetSearchSubmit,

        activeSearchType,
        setActiveSearchType,

    } = useContext(ResearchContext);

    const {
        tipiUfficiRicercaOptions,
        comuniOptions,
        regioniOptions,
        provinceOptions,
        distrettiOptions,
        circondariOptions,
        province,
    } = state;

    const isLoading = isLoadingComuni || isLoadingRegioni || isLoadingProvince || isLoadingDistretti || isLoadingCircondari;

    return (
        <>
            {
                isLoading &&
                <LinearProgress />
            }
            <Grid container paddingY={2} alignItems='flex-end'>
                <Grid item xs={12} container>
                    <Grid item xs='auto' padding={1} container justifyContent='flex-end'>
                        <Grid item xs>
                            <FormControl>
                                <InputLabel>
                                    Tipo ricerca
                                </InputLabel>
                                <Select
                                    sx={{ minWidth: '230px' }}
                                    label='Tipo ricerca'
                                    value={activeSearchType}
                                    disabled={isLoadingFilterFromCookies}
                                    onChange={e => setActiveSearchType(e.target.value)}>
                                    {
                                        SearchTypeOptions.map(e =>
                                            <MenuItem value={e.tipo} key={e.tipo}>
                                                {e.label}
                                            </MenuItem>
                                        )
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    {
                        activeSearchType === "" &&
                        <Grid item md xs={12} container alignItems="center">
                            <Typography variant='h6' color='textSecondary' sx={{marginLeft:2}}>
                                Selezionare un tipo di ricerca
                            </Typography>
                        </Grid>
                    }
                    <Grid item md xs={12} container>
                        <ComuneFilter />
                        <DistrettualeFilter />
                        <TerritorioFilter />
                        <TipoUfficioFilter />
                        <LiberaFilter />
                    </Grid>
                    {
                        activeSearchType !== "" && !isLoading &&
                        <Grid item xs='auto' padding={1} container justifyContent='flex-end' columnSpacing={2}>
                            <Grid item md xs='auto'>
                                <Button variant='contained' disabled={isLoadingFilterFromCookies} disableElevation fullWidth sx={{ height: '57px' }} onClick={handleSearchSubmit}>
                                    {
                                        (isLoadingUffici || isLoadingComuneAltriUffici || isLoadingComuneUffici || isLoadingUfficiDistretto || isLoadingUfficiTerritorio || isLoadingUfficiTipoUfficio || isLoadingUfficiLibera) ?
                                            <CircularProgress sx={{ color: "white" }} size={24} />
                                            :
                                            <SearchIcon />
                                    }
                                </Button>
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </Grid>
        </>
    );
}